const elemAccordionItem = document.querySelectorAll('.Faq__Item');

for(let i = 0; i < elemAccordionItem.length; i++) {

  elemAccordionItem[i].addEventListener('click', function(e) {
    e.preventDefault();
// console.log(e.currentTarget);
    let elemAccordionBtn = e.currentTarget.querySelector('.Faq__ItemWrapper');
    let elemAccordionPanel = e.currentTarget.querySelector('.Faq__AnswerWrapper');
    let elemAccordionAnswer = e.currentTarget.querySelector('.Faq__Answer');

    this.classList.toggle('is-active');

    if(elemAccordionBtn.getAttribute('aria-expanded') === 'false') {
      elemAccordionBtn.setAttribute('aria-expanded', 'true');
      elemAccordionPanel.setAttribute('aria-hidden', 'false');
      // elemAccordionAnswer.scrollHeight
      elemAccordionPanel.style.height = elemAccordionPanel.scrollHeight+'px';
    } else {
      elemAccordionBtn.setAttribute('aria-expanded', 'false');
      elemAccordionPanel.setAttribute('aria-hidden', 'true');
      elemAccordionPanel.style.height = '0px';

    }
  })
}
